<ui-dialog width="sm" titleDivider noDialogActions customCloseEvent (closed)="onClose()">
  <ng-container dialog-title>Login KFZ-Portal</ng-container>
  <ng-container dialog-content>
    @if (facade.login.data()) {
      <div class="flex items-center gap-3 pt-2 pb-11 text-cp-primary-100">
        <mat-icon svgIcon="cp-check" />
        <span class="text-lg font-bold">Erfolgreich angemeldet</span>
      </div>
      <div class="flex flex-wrap items-center justify-between gap-4">
        <a
          [href]="portalDashboardUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="text-cp-primary-100 underline"
        >
          Zum Kundenportal
        </a>
        <button mat-flat-button color="accent" class="btn-primary-lg" (click)="onClose()">
          Schließen
        </button>
      </div>
    } @else {
      @if (data.reason === 'rueckruf') {
        <p class="m-0 mb-6 text-sm text-cp-primary-100">
          Um einen Vorschlag zu speichern und einen Rückruf zu vereinbaren, melde dich bitte an.
          <br />
          Solltest du noch keinen Zugang haben, wähle bitte „Registrieren“, um einen anzulegen.
        </p>
      } @else if (data.mode === 'gated') {
        <!-- One line for both gated cases: a claimed-task restore and a session
             that died mid-funnel. Restore-specific wording would be wrong in an
             Antrag. -->
        <p class="m-0 mb-6 text-sm text-cp-primary-100">Bitte melde dich an, um fortzufahren.</p>
      }
      @if (data.reason === 'rueckruf' || data.mode === 'default' || data.taskToken) {
        <p class="m-0 mb-2 text-sm text-cp-primary-100">
          Du hast bereits einen
          <a
            [href]="financialHomeUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="font-bold text-cp-primary-100 underline"
          >
            MLP Financial Home
          </a>
          Zugang?
        </p>
        <p class="m-0 mb-6 text-sm text-cp-primary-80">
          Dann <span class="underline">musst</span> du das KFZ-Portal auch von dort aufrufen. Eine
          neue Registrierung ist in diesem Fall nicht erforderlich.
        </p>
      }

      @if (facade.login.error(); as error) {
        <div class="mb-4 rounded-lg border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-700">
          {{ error }}
        </div>
      }

      <mat-form-field class="w-full">
        <mat-label>Benutzername oder E-Mail-Adresse</mat-label>
        <input matInput [formControl]="benutzername" (keydown.enter)="submit()" />
        <mat-error ui-input-errors [control]="benutzername"></mat-error>
      </mat-form-field>

      <mat-form-field class="w-full mt-4">
        <mat-label>Passwort</mat-label>
        <input matInput type="password" [formControl]="kennwort" (keydown.enter)="submit()" />
        <mat-error ui-input-errors [control]="kennwort"></mat-error>
      </mat-form-field>

      <div class="flex flex-col gap-4 mt-6">
        <button
          mat-flat-button
          color="accent"
          class="btn-primary-lg w-full"
          [disabled]="facade.login.loading()"
          (click)="submit()"
        >
          @if (facade.login.loading()) {
            <mat-spinner diameter="20" />
          } @else {
            Einloggen
          }
        </button>

        <a
          mat-stroked-button
          [href]="registrationUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="btn-secondary-lg w-full"
        >
          Registrieren
        </a>
      </div>

      <a
        [href]="passwordResetUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="mt-6 inline-block text-cp-primary-100 underline text-sm"
      >
        Passwort vergessen?
      </a>
    }
  </ng-container>
</ui-dialog>
